<template>
  <div class="wrong-detail">
    <el-page-header @back="$router.go(-1)" content="错题信息"> </el-page-header>
    <div class="main">
      <p class="chapter">
        所属章节：
        <span v-for="(item, idx) in questionInfo.chapterNames" :key="idx">
          <span v-show="idx">~</span> {{ item }}
        </span>
      </p>
      <span class="type">({{ checkType(questionInfo.type) }})</span>
      <p class="stem">{{ questionInfo.question }}</p>
      <div class="options">
        <p
          class="option"
          v-for="item in questionInfo.optionList"
          :key="item.tag"
        >
          <span class="tag">{{ item.tag }}.</span>
          <span class="text">{{ item.option }}</span>
        </p>
      </div>
      <div class="answers">
        <p class="my-answer">
          我的答案：{{ [...questionInfo.myAnswerList].sort().join(",") }}
        </p>
        <p class="correct-answer">
          正确答案：{{ questionInfo.answerList.join(",") }}
        </p>
      </div>
      <!-- <p class="rate">班级正确率：{{ questionInfo.correctRate }}%</p> -->
    </div>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
export default {
  data() {
    return {
      checkType,
      questionInfo: JSON.parse(this.$route.query.questionInfo),
    };
  },
  activated() {
    this.questionInfo = JSON.parse(this.$route.query.questionInfo);
  },
};
</script>

<style lang="less" scoped>
.wrong-detail {
  padding: 33px;
  background-color: rgb(255, 255, 255);
  ::v-deep .el-page-header {
    .el-page-header__content {
      font-size: 14px;
    }
  }
  .main {
    margin-top: 30px;
    text-align: left;
    .chapter {
      margin-bottom: 20px;
      font-weight: bold;
    }
    .type {
      display: inline-block;
      margin-right: 10px;
      color: #969696;
      vertical-align: top;
    }
    .stem {
      display: inline-block;
      max-width: 94%;
      color: #333;
      vertical-align: top;
    }
    .options {
      margin-left: 60px;
      margin-top: 20px;
      .option {
        margin-bottom: 20px;
        .tag {
          margin-right: 5px;
        }
      }
    }
    .answers {
      margin-top: 20px;
      .my-answer {
        margin-bottom: 10px;
        color: #f56c6c;
      }
      .correct-answer {
        color: #67c23a;
      }
    }
    .rate {
      margin-top: 10px;
      color: #409eff;
    }
  }
}
</style>